import { render, staticRenderFns } from "./GerarRelatoriosClientes.vue?vue&type=template&id=25c918aa&scoped=true&"
import script from "./GerarRelatoriosClientes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosClientes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosClientes.vue?vue&type=style&index=0&id=25c918aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c918aa",
  null
  
)

export default component.exports